<header
  class="header-container outline-header ios-padding-left ios-padding-right"
>
  <nav class="navbar navbar-expand-lg navbar-light">
    <!-- Visible on large devices -->
    <div class="container-fluid p0 visible-lg-up">
      <div class="col p0 d-flex justify-content-start">
        <app-logo
          [tenantInInternalPool]="tenantInInternalPool()"
          [targetHandling]="'_self'"
        ></app-logo>
      </div>
      <div class="col-6 d-flex justify-content-end">
        <div class="d-flex justify-content-end">
          <ul class="navbar-nav justify-content-end align-items-center">
            <li class="nav-item">
              @if (showLanguagePicker()) {
                <app-lang-picker
                  [availableLanguages]="availableLanguages()"
                  [defaultLanguageCode]="defaultLanguageCode()"
                  [ghostButton]="true"
                  [ngModel]="currentLanguageCode()"
                  (ngModelChange)="onLanguageChange($event)"
                ></app-lang-picker>
              }
            </li>
            <li class="nav-item d-inline-block">
              <button
                (click)="profileSettingsToggle.emit()"
                class="btn-sm"
                im-button
              >
                {{ 'header.account_settings_l' | translate }}
                <svg-icon
                  iconEnd
                  src="/assets/images/icons/nav-settings.svg"
                  [applyClass]="true"
                  [svgStyle]="{ 'width.px': 15 }"
                  class="primary-text-svg-color path settings_icon"
                ></svg-icon>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
